import {
  DevicePhoneMobileIcon,
  UserIcon,
  CheckCircleIcon,
  TagIcon,
  CalendarIcon,
  CakeIcon,
  WrenchScrewdriverIcon,
  ChatBubbleLeftRightIcon,
  LinkIcon,
  CursorArrowRaysIcon,
  ShoppingBagIcon,
} from "@heroicons/react/16/solid";

export const filterOptions = [
  {
    type: "phone",
    label: "Phone",
    icon: <DevicePhoneMobileIcon className="h-4 w-4" />,
    description: "Contact phone number",
    inputType: "string", // string, tag, number, date, etc.
    placeholder: "Enter phone number",
    operators: [
      {
        key: "equals",
        label: "is",
        requiresValue: true,
        placeholder: "Enter phone number",
      },
      {
        key: "startsWith",
        label: "starts with",
        requiresValue: true,
        placeholder: "Enter phone prefix",
        maxLength: 15,
      },
      {
        key: "isSet",
        label: "has any value",
        requiresValue: false,
      },
    ],
  },
  {
    type: "whatsappName",
    label: "WhatsApp pseudo",
    icon: <UserIcon className="h-4 w-4" />,
    description: "Contact WhatsApp name",
    inputType: "string",
    placeholder: "Enter WhatsApp name",
    operators: [
      {
        key: "is",
        label: "is",
        requiresValue: true,
        placeholder: "Enter WhatsApp name",
      },
      {
        key: "isNot",
        label: "is not",
        requiresValue: true,
        placeholder: "Enter WhatsApp name",
      },
    ],
  },
  {
    type: "firstName",
    label: "First name",
    icon: <UserIcon className="h-4 w-4" />,
    description: "Contact first name",
    inputType: "string",
    placeholder: "Enter first name",
    operators: [
      {
        key: "is",
        label: "is",
        requiresValue: true,
        placeholder: "Enter first name",
      },
      {
        key: "isNot",
        label: "is not",
        requiresValue: true,
        placeholder: "Enter first name",
      },
    ],
  },

  {
    type: "lastName",
    label: "Last name",
    icon: <UserIcon className="h-4 w-4" />,
    description: "Contact last name",
    inputType: "string",
    placeholder: "Enter last name",
    operators: [
      {
        key: "is",
        label: "is",
        requiresValue: true,
        placeholder: "Enter last name",
      },
      {
        key: "isNot",
        label: "is not",
        requiresValue: true,
        placeholder: "Enter last name",
      },
    ],
  },
  {
    type: "optinStatus",
    label: "Optin status",
    icon: <CheckCircleIcon className="h-4 w-4" />,
    description: "Optin or consent or optout status",
    inputType: "optinStatus",
    placeholder: "Select optin status",
    operators: [
      {
        key: "is",
        label: "is",
        requiresValue: true,
        placeholder: "Select optin status",
      },
      {
        key: "isNot",
        label: "is not",
        requiresValue: true,
        placeholder: "Select optin status",
      },
    ],
    values: [
      { key: "optin", label: "Optin" },
      { key: "neverOptin", label: "Never optin" },
      { key: "optout", label: "Optout" },
    ],
  },

  {
    type: "createdAt",
    label: "Created",
    icon: <CalendarIcon className="h-4 w-4" />,
    description: "Contact creation date",
    inputType: "date",
    placeholder: "Select date",
    operators: [
      {
        key: "moreThan",
        label: "more than",
        requiresValue: true,
        placeholder: "Number",
        isRelative: true,
        inputType: "number",
      },
      {
        key: "lessThan",
        label: "less than",
        requiresValue: true,
        placeholder: "Number",
        isRelative: true,
        inputType: "number",
      },
      {
        key: "after",
        label: "after",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
      {
        key: "before",
        label: "before",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
      {
        key: "on",
        label: "on",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
    ],
  },
  {
    type: "optinAt",
    label: "Opted-in",
    icon: <CalendarIcon className="h-4 w-4" />,
    description: "Contact opt-in or consent date",
    inputType: "date",
    placeholder: "Select date",
    operators: [
      {
        key: "moreThan",
        label: "more than",
        requiresValue: true,
        placeholder: "Number",
        isRelative: true,
        inputType: "number",
      },
      {
        key: "lessThan",
        label: "less than",
        requiresValue: true,
        placeholder: "Number",
        isRelative: true,
        inputType: "number",
      },
      {
        key: "after",
        label: "after",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
      {
        key: "before",
        label: "before",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
      {
        key: "on",
        label: "on",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
    ],
  },
  {
    type: "optoutAt",
    label: "Opted-out",
    icon: <CalendarIcon className="h-4 w-4" />,
    description: "Contact opt-out date",
    inputType: "date",
    placeholder: "Select date",
    operators: [
      {
        key: "moreThan",
        label: "more than",
        requiresValue: true,
        placeholder: "Number",
        isRelative: true,
        inputType: "number",
      },
      {
        key: "lessThan",
        label: "less than",
        requiresValue: true,
        placeholder: "Number",
        isRelative: true,
        inputType: "number",
      },
      {
        key: "after",
        label: "after",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
      {
        key: "before",
        label: "before",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
      {
        key: "on",
        label: "on",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
    ],
  },
  {
    type: "birthday",
    label: "Birthday",
    icon: <CakeIcon className="h-4 w-4" />,
    description: "Contact birthday, date of birth, birthdate",
    inputType: "date",
    placeholder: "Select date",
    operators: [
      {
        key: "moreThan",
        label: "more than",
        requiresValue: true,
        placeholder: "Number",
        isRelative: true,
        inputType: "number",
      },
      {
        key: "lessThan",
        label: "less than",
        requiresValue: true,
        placeholder: "Number",
        isRelative: true,
        inputType: "number",
      },
      {
        key: "after",
        label: "after",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
      {
        key: "before",
        label: "before",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
      {
        key: "on",
        label: "on",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
    ],
  },
  {
    type: "tag",
    label: "Tags",
    icon: <TagIcon className="h-4 w-4" />,
    description: "Contact tags",
    inputType: "tag",
    placeholder: "Select a tag",
    operators: [
      {
        key: "contains",
        label: "contains",
        requiresValue: true,
        placeholder: "Select a tag",
      },
      {
        key: "excludes",
        label: "excludes",
        requiresValue: true,
        placeholder: "Select a tag",
      },
    ],
  },
  {
    type: "customField",
    label: "Custom field",
    icon: <WrenchScrewdriverIcon className="h-4 w-4" />,
    description: "Contact custom field",
    inputType: "customField",
    placeholder: "Select custom field",
    operators: [
      {
        key: "is",
        label: "is",
        requiresValue: true,
        placeholder: "Enter value",
        inputType: "string",
      },
      {
        key: "isNot",
        label: "is not",
        requiresValue: true,
        placeholder: "Enter value",
        inputType: "string",
      },
    ],
  },
  {
    type: "receivedMessageAt",
    label: "Received message",
    icon: <ChatBubbleLeftRightIcon className="h-4 w-4" />,
    description: "Received message date, sent, delivered, read",
    inputType: "messageFrequency",
    placeholder: "Select frequency",
    frequencyOptions: [
      { value: "atLeastOnce", label: "at least once" },
      { value: "zeroTimes", label: "zero times" },
    ],
    campaignOptions: [
      { value: "any", label: "from any flow" },
      { value: "campaign", label: "from campaign" },
      { value: "automation", label: "from automation" },
    ],
    operators: [
      {
        key: "overAllTime",
        label: "over all time",
        requiresValue: false,
      },
      {
        key: "moreThan",
        label: "more than",
        requiresValue: true,
        placeholder: "Number",
        isRelative: true,
        inputType: "number",
      },
      {
        key: "lessThan",
        label: "less than",
        requiresValue: true,
        placeholder: "Number",
        isRelative: true,
        inputType: "number",
      },
      {
        key: "after",
        label: "after",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
      {
        key: "before",
        label: "before",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
      {
        key: "on",
        label: "on",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
    ],
  },

  {
    type: "openedMessageAt",
    label: "Opened message",
    icon: <ChatBubbleLeftRightIcon className="h-4 w-4" />,
    description: "Opened message date",
    inputType: "messageFrequency",
    placeholder: "Select frequency",
    frequencyOptions: [
      { value: "atLeastOnce", label: "at least once" },
      { value: "zeroTimes", label: "zero times" },
    ],
    campaignOptions: [
      { value: "any", label: "from any flow" },
      { value: "campaign", label: "from campaign" },
      { value: "automation", label: "from automation" },
    ],
    operators: [
      {
        key: "overAllTime",
        label: "over all time",
        requiresValue: false,
      },
      {
        key: "moreThan",
        label: "more than",
        requiresValue: true,
        placeholder: "Number",
        isRelative: true,
        inputType: "number",
      },
      {
        key: "lessThan",
        label: "less than",
        requiresValue: true,
        placeholder: "Number",
        isRelative: true,
        inputType: "number",
      },
      {
        key: "after",
        label: "after",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
      {
        key: "before",
        label: "before",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
      {
        key: "on",
        label: "on",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
    ],
  },
  {
    type: "clickedUrlAt",
    label: "Clicked URL",
    icon: <LinkIcon className="h-4 w-4" />,
    description: "Clicked URL date",
    inputType: "messageFrequency",
    placeholder: "Select frequency",
    frequencyOptions: [
      { value: "atLeastOnce", label: "at least once" },
      { value: "zeroTimes", label: "zero times" },
    ],
    campaignOptions: [
      { value: "any", label: "in any flow" },
      { value: "campaign", label: "in campaign" },
      { value: "automation", label: "in automation" },
      { value: "chatbot", label: "in chatbot" },
    ],
    operators: [
      {
        key: "overAllTime",
        label: "over all time",
        requiresValue: false,
      },
      {
        key: "moreThan",
        label: "more than",
        requiresValue: true,
        placeholder: "Number",
        isRelative: true,
        inputType: "number",
      },
      {
        key: "lessThan",
        label: "less than",
        requiresValue: true,
        placeholder: "Number",
        isRelative: true,
        inputType: "number",
      },
      {
        key: "after",
        label: "after",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
      {
        key: "before",
        label: "before",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
      {
        key: "on",
        label: "on",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
    ],
  },
  {
    type: "clickedButtonAt",
    label: "Clicked button",
    icon: <CursorArrowRaysIcon className="h-4 w-4" />,
    description: "Clicked button date, quick reply",
    inputType: "messageFrequency",
    placeholder: "Select frequency",
    frequencyOptions: [
      { value: "atLeastOnce", label: "at least once" },
      { value: "zeroTimes", label: "zero times" },
    ],
    campaignOptions: [
      { value: "any", label: "in any flow" },
      { value: "campaign", label: "in campaign" },
      { value: "automation", label: "in automation" },
      { value: "chatbot", label: "in chatbot" },
    ],
    operators: [
      {
        key: "overAllTime",
        label: "over all time",
        requiresValue: false,
      },
      {
        key: "moreThan",
        label: "more than",
        requiresValue: true,
        placeholder: "Number",
        isRelative: true,
        inputType: "number",
      },
      {
        key: "lessThan",
        label: "less than",
        requiresValue: true,
        placeholder: "Number",
        isRelative: true,
        inputType: "number",
      },
      {
        key: "after",
        label: "after",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
      {
        key: "before",
        label: "before",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
      {
        key: "on",
        label: "on",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
    ],
  },
  {
    type: "placedOrderAt",
    label: "Placed order",
    icon: <ShoppingBagIcon className="h-4 w-4" />,
    description: "Placed order date, purchased, bought, attributed sales",
    inputType: "messageFrequency",
    placeholder: "Select frequency",
    frequencyOptions: [
      { value: "atLeastOnce", label: "at least once" },
      { value: "zeroTimes", label: "zero times" },
    ],
    campaignOptions: [
      { value: "any", label: "from any flow" },
      { value: "campaign", label: "from campaign" },
      { value: "automation", label: "from automation" },
    ],
    operators: [
      {
        key: "overAllTime",
        label: "over all time",
        requiresValue: false,
      },
      {
        key: "moreThan",
        label: "more than",
        requiresValue: true,
        placeholder: "Number",
        isRelative: true,
        inputType: "number",
      },
      {
        key: "lessThan",
        label: "less than",
        requiresValue: true,
        placeholder: "Number",
        isRelative: true,
        inputType: "number",
      },
      {
        key: "after",
        label: "after",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
      {
        key: "before",
        label: "before",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
      {
        key: "on",
        label: "on",
        requiresValue: true,
        placeholder: "Select date",
        isRelative: false,
        inputType: "date",
      },
    ],
  },
];

// Helper function to get filter option by type
export const getFilterOption = (type) => {
  return filterOptions.find((opt) => opt.type === type);
};

// Helper function to get operator by filter type and operator key
export const getOperator = (filterType, operatorKey) => {
  const filterOption = getFilterOption(filterType);
  if (!filterOption) return null;
  return filterOption.operators.find((op) => op.key === operatorKey);
};

// Helper function to get filter options with custom fields included in Custom Field description
export const getFilterOptionsWithCustomFields = (customFields = {}) => {
  const customFieldNames = Object.keys(customFields);
  const customFieldNamesText =
    customFieldNames.length > 0 ? ` (${customFieldNames.join(", ")})` : "";

  return filterOptions.map((option) => {
    if (option.type === "customField") {
      return {
        ...option,
        description: `Contact custom field${customFieldNamesText}`,
      };
    }
    return option;
  });
};

// Helper function to get filter options filtered by integrations
export const getFilterOptionsWithIntegrations = (
  integrations = {},
  customFields = {},
) => {
  const options = getFilterOptionsWithCustomFields(customFields || {});

  return options.filter((option) => {
    // Show placed order filter only if Shopify integration is enabled
    if (option.type === "placedOrderAt") {
      return integrations.shopify === true;
    }

    // Show all other filters
    return true;
  });
};
